import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FooterComponent } from './footer.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';

@NgModule({
  declarations: [
    FooterComponent
  ],
  imports: [
    TranslateModule,
    CommonModule,
    LocalizeRouterModule,
    RouterModule
  ],
  exports: [
    FooterComponent
  ]
})

export class FooterModule { }
